import { Badge, Container, InfoWrapper, JackpotLabel, ProductImage, ProductName, Row } from './styles'

interface JackpotItemProps {
  imageSrc: string
  badgeLabel: string
  productName: string
}

export default function JackpotItem({ imageSrc, badgeLabel, productName }: JackpotItemProps) {
  return (
    <Container>
      <ProductImage src={imageSrc} alt={productName} />
      <InfoWrapper>
        <Row>
          <Badge>{badgeLabel}</Badge>
          <JackpotLabel>이달의 잭팟 1명!</JackpotLabel>
        </Row>
        <ProductName>{productName}</ProductName>
      </InfoWrapper>
    </Container>
  )
}
